export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-competencies-item.vue?vue&type=template&id=2be0c9ae&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-competencies-item/lk-competencies-item.vue?vue&type=template&id=2be0c9ae&
// module id = 1072
// module chunks = 0